/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
Vue.component("axios", Axios)


// Bootstrap
import '@/styles/main.scss'

//i18n
import i18n from './i18n'

//scrolling to anchors
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

// Scrollmagic
import VueScrollmagic from 'vue-scrollmagic'
Vue.use(VueScrollmagic)

// AOS (animate on scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';

Vue.config.productionTip = false

import VueSlideBar from 'vue-slide-bar'
Vue.component('vue-slide-bar', VueSlideBar)

export const EventBus = new Vue();
import $ from "jquery";

Vue.mixin({
  methods:{
    resetScrollIndicator: function () {
      EventBus.$emit('reset');
    },
    incrementScrollIndicator: function (incrementValue, s) {
      EventBus.$emit('increment', incrementValue, s);
    },
    isInViewport: function (elem) {
      var bounding = elem.getBoundingClientRect();
      let elHeight = elem.offsetHeight;
      let elWidth = elem.offsetWidth;
      if (bounding.top >= -elHeight
          && bounding.left >= -elWidth
          && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + elWidth
          && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elHeight) {
        return true
      } else {
        return false
      }
    },
    allSeen: function(array){
      let isValid = true;
      for (let i = 0; i < array.length; i++) {
        if(array[i] == 0){
          isValid = false;
        }
      }
      return isValid;
    },
    refreshAOS: function () {
      AOS.refresh();
    }
  }
})

new Vue({
  created () {
    AOS.init()
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
